<div id="newGarmin"  >
  <div id="garmin">
    <div class="circle">
      <div class="blue">
        <div class="inner">
          <h2 class="circleTitle">{{activity.moving_time | elapsed }}</h2>
          <h3 class="circleSubtitle">Time</h3>
        </div>
      </div>
    </div>
    <div class="circle" *ngIf="activity.distance>0">
      <div class="orange">
        <div class="inner">
          <h2 class="circleTitle">{{activity.distance | distance:'none'}}</h2>
          <h3 class="circleSubtitle">Distance ({{measurementType}})</h3>
        </div>
      </div>
    </div>
    <div class="circle" *ngIf="activity.distance === 0">
      <div class="orange">
        <div class="inner">
          <h2 class="circleTitle">{{activity.average_heartrate}}</h2>
          <h3 class="circleSubtitle">Avg Heartrate</h3>
        </div>
      </div>
    </div>
    <div class="circle" *ngIf="activity.calories">
      <div class="green">
        <div class="inner">
          <h2 class="circleTitle">{{activity.calories}}</h2>
          <h3 class="circleSubtitle">Calories</h3>
        </div>
      </div>
    </div>
    <div class="circle" *ngIf="!activity.calories">
      <div class="green">
        <div class="inner">
          <h2 class="circleTitle">{{activity.pace | elapsed}}</h2>
          <h3 class="circleSubtitle">Pace</h3>
        </div>
      </div>
    </div>
  </div>
</div>
